import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SET_API_ROOT_INDEX, SET_USE_PROD, SET_AD_BLOCKER } from '../actions/types';
var initialState = {
  value: 0,
  useProd: null
};
export var apiRootReducer = function apiRootReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_API_ROOT_INDEX:
      return _objectSpread(_objectSpread({}, state), {}, {
        value: action.payload
      });

    case SET_USE_PROD:
      return _objectSpread(_objectSpread({}, state), {}, {
        useProd: action.payload
      });

    case SET_AD_BLOCKER:
      return _objectSpread(_objectSpread({}, state), {}, {
        adBlockerEnabled: action.payload
      });

    default:
      return state;
  }
};